import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M15.04 19.04l9.568-9.568a1.165 1.165 0 111.663 1.632L15.103 22.272l-6.784-6.72a1.152 1.152 0 011.634-1.598l-.002-.002z" /></svg>;